import { render, staticRenderFns } from "./sms-info-template.vue?vue&type=template&id=3d5fa040&scoped=true"
import script from "./sms-info-template.vue?vue&type=script&lang=js"
export * from "./sms-info-template.vue?vue&type=script&lang=js"
import style0 from "./sms-info-template.vue?vue&type=style&index=0&id=3d5fa040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5fa040",
  null
  
)

export default component.exports